import Cookies from "js-cookie";
import {
  getCallCenterBaseUrl,
  requestCallCenter,
  unwrapEnvelopeValue,
} from "./CallCenterApi";

export const createManualCall = async (payload) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: "calls/manual",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to create manual call");
};

export const triggerAICall = async (payload) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: "calls/ai/trigger",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to trigger AI call");
};

export const getCallById = async (callId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `calls/${callId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to fetch call details");
};

/**
 * @param {string} callId
 * @param {import("./CallCenterApi").ManualCallStatusUpdateRequest} payload
 */
export const updateCallManualStatus = async (callId, payload) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: `calls/${callId}/manual-status`,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update call status");
};

/**
 * Preferred manual-tracking endpoint for frontend.
 * Backend resolves the target call by JWT user context + accountNo.
 * @param {import("./CallCenterApi").ManualCallStatusByAccountRequest} payload
 */
export const updateManualStatusByAccount = async (payload) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: "calls/manual-status",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update call status");
};

export const getOfficeUsers = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "calls/office-users",
  });
  return unwrapEnvelopeValue(envelope, "Failed to fetch office users");
};

/**
 * SSE: native EventSource cannot send Authorization. Backend accepts JWT in the query
 * (access_token or token) — we use access_token, URL-encoded.
 * @param {string} callId
 * @returns {string}
 */
export const getCallStreamUrl = (callId) => {
  const path = `api/calls/${callId}/stream`;
  const base = `${getCallCenterBaseUrl()}${path}`;
  const token = Cookies.get("accessToken");
  if (!token) return base;
  const join = base.includes("?") ? "&" : "?";
  return `${base}${join}access_token=${encodeURIComponent(token)}`;
};
